import { useState, useEffect } from "react";

let _cache = null;
let _pending = null;

export function useCollectionCounts() {
  const [counts, setCounts] = useState(_cache);
  useEffect(() => {
    if (_cache) return;
    _pending = _pending || fetch(`${process.env.REACT_APP_BACKEND_URL}/api/collections/counts`)
      .then((r) => r.json()).then((d) => { _cache = d.counts || {}; return _cache; }).catch(() => ({}));
    _pending.then((c) => setCounts(c));
  }, []);
  return counts;
}

export const collectionOfLink = (to) => {
  const m = /[?&]collection=([^&]+)/.exec(to || "");
  return m ? decodeURIComponent(m[1]) : null;
};

// Links without a collection param are always live; while counts are loading, everything is live.
export const isLiveLink = (to, counts) => {
  if ((to || "").startsWith("/bundle-builder")) return !counts || (counts["bundle-builder"] || 0) > 0;
  const slug = collectionOfLink(to);
  if (!slug || !counts) return true;
  return (counts[slug] || 0) > 0;
};
